import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function GreaterThanValidator(otherControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const otherControl = control.parent?.get(otherControlName);

    if (!otherControl) {
      return null;
    }

    if (control.value <= otherControl.value) {
      return { 'greaterThan': true };
    }

    return null;
  };
}
